import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import styles from "./styles.module.scss";
import useSubscriptionHook from "../../SubscriptionPageV2/YourSubscriptionV2/useYourSubscriptionV2";
import CircularProgress from "@mui/material/CircularProgress";
import LoadReferalInfoThunk from "../../../redux/thunkCreators/referalInfo/referalInfo";
import { useDispatch } from "react-redux";
const ReferralCard = ({ name, clickable, cta, color, helpText }) => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const [style, setStyle] = useState({ background: color, color: "" });
    const { applyPromo, removePromo } = useSubscriptionHook();
    const getColorClass = () => {
        switch (color) {
            case 'dark':
                return styles.dark;
            case 'light':
                return styles.light;
            case 'grey':
                return styles.grey;
            default:
                return '';
        }
    };
    const apply = async () => {
        setLoading(true);
        await applyPromo("referral");
        await dispatch(LoadReferalInfoThunk(false));
        setLoading(false);
    };
    return (_jsxs("div", { className: `${styles.card} ${!clickable ? styles.nonclickable : ""}`, onClick: clickable ? apply : undefined, children: [_jsxs("div", { className: styles.top, children: [_jsxs("div", { className: styles.left, children: [_jsx("span", { className: styles.span, children: "Referral Credit" }), _jsxs("span", { className: styles.span, children: ["Referred: ", _jsx("span", { className: styles.name, children: name })] })] }), _jsx("div", { className: styles.chip, children: "40% off" })] }), _jsx("div", { className: `${styles.cta} ${getColorClass()}`, children: loading ? _jsx(CircularProgress, { size: 25, className: styles.spinner }) : _jsx("span", { children: cta }) })] }));
};
export default ReferralCard;
